__turbopack_context__.v({
  "mobileHeroCarousel": "MobileCarousel-module-scss-module__VE6eWG__mobileHeroCarousel",
});
